import { IconType } from "react-icons";
import PropTypes from "prop-types";

interface IconStar {
    icon: IconType;
    size: number;
}

const IconComponent: React.FC<IconStar> = ({ icon, size }) => {
    const IconElement = icon as React.ElementType;
    return <IconElement size={size} />;
};

IconComponent.propTypes = {
    icon: PropTypes.func.isRequired,
};

export default IconComponent;